import bulmaModal from "./modal";
import toggleCareer from "./toggle";

const init = () => {
	bulmaModal();
	toggleCareer();
}

//init
if (document.readyState !== "loading") {
	init();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		init();
	})
}